@if (isLoading()) {

  <div
    class="loading-main-container absolute z-[9999999999] h-full w-full bg-black/20"
  >

    <div
      class="loader-container absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >

      <!-- Loader -->
      <div class="loader text-center">

        <isc-lottie-animation
          height="250px"
          [options]="lottieOptions"
        />

      </div>

      <!-- Message -->
      @if (showMsg()) {
        <div class="text-center text-white">
          {{ message() }}
        </div>
      }

      <!-- Progress -->
      @if (progressPercent() !== null) {

        <div
          class="mx-auto -mt-[30px] w-fit rounded-sm bg-slate-100 px-2 text-center text-primary shadow-md"
        >
          Uploading file...
          <span class="font-bold">
            {{ progressPercent() }}%
          </span>
        </div>

      }

    </div>

  </div>

}